import * as le from "react";
import at, { forwardRef as ot, useContext as it, useState as Mr, useCallback as Fr, useMemo as Ue, useEffect as Bt } from "react";
import { css as Y } from "@emotion/react";
import { getColor as J, getColorShadow as Ut, applyBoxStyle as qt, deleteCssProps as Gt } from "@illa-design/theme";
import { useMergeValue as jr, isFunction as Jt } from "@illa-design/system";
import { ConfigProviderContext as Kt, def as Ht } from "@illa-design/config-provider";
import { MoreIcon as qe, PreviousIcon as Vr, NextIcon as Lr } from "@illa-design/icon";
import { Select as Zt } from "@illa-design/select";
var lr = { exports: {} }, Ae = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yr;
function Xt() {
  if (Yr)
    return Ae;
  Yr = 1;
  var e = at, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, p, y) {
    var d, b = {}, j = null, A = null;
    y !== void 0 && (j = "" + y), p.key !== void 0 && (j = "" + p.key), p.ref !== void 0 && (A = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (b[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        b[d] === void 0 && (b[d] = p[d]);
    return { $$typeof: r, type: l, key: j, ref: A, props: b, _owner: o.current };
  }
  return Ae.Fragment = t, Ae.jsx = f, Ae.jsxs = f, Ae;
}
var Ie = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zr;
function Qt() {
  return zr || (zr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = at, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), M = Symbol.iterator, m = "@@iterator";
    function x(n) {
      if (n === null || typeof n != "object")
        return null;
      var s = M && n[M] || n[m];
      return typeof s == "function" ? s : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(n) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), g = 1; g < s; g++)
          u[g - 1] = arguments[g];
        C("error", n, u);
      }
    }
    function C(n, s, u) {
      {
        var g = E.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (s += "%s", u = u.concat([$]));
        var V = u.map(function(w) {
          return String(w);
        });
        V.unshift("Warning: " + s), Function.prototype.apply.call(console[n], console, V);
      }
    }
    var F = !1, c = !1, z = !1, T = !1, Pe = !1, de;
    de = Symbol.for("react.module.reference");
    function he(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === a || n === i || Pe || n === o || n === y || n === d || T || n === A || F || c || z || typeof n == "object" && n !== null && (n.$$typeof === j || n.$$typeof === b || n.$$typeof === f || n.$$typeof === l || n.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === de || n.getModuleId !== void 0));
    }
    function X(n, s, u) {
      var g = n.displayName;
      if (g)
        return g;
      var $ = s.displayName || s.name || "";
      return $ !== "" ? u + "(" + $ + ")" : u;
    }
    function O(n) {
      return n.displayName || "Context";
    }
    function ee(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case a:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case y:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case l:
            var s = n;
            return O(s) + ".Consumer";
          case f:
            var u = n;
            return O(u._context) + ".Provider";
          case p:
            return X(n, n.render, "ForwardRef");
          case b:
            var g = n.displayName || null;
            return g !== null ? g : ee(n.type) || "Memo";
          case j: {
            var $ = n, V = $._payload, w = $._init;
            try {
              return ee(w(V));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, oe = 0, me, pe, ue, ye, W, G, _e;
    function xe() {
    }
    xe.__reactDisabledLog = !0;
    function ge() {
      {
        if (oe === 0) {
          me = console.log, pe = console.info, ue = console.warn, ye = console.error, W = console.group, G = console.groupCollapsed, _e = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: xe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        oe++;
      }
    }
    function $e() {
      {
        if (oe--, oe === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, n, {
              value: me
            }),
            info: P({}, n, {
              value: pe
            }),
            warn: P({}, n, {
              value: ue
            }),
            error: P({}, n, {
              value: ye
            }),
            group: P({}, n, {
              value: W
            }),
            groupCollapsed: P({}, n, {
              value: G
            }),
            groupEnd: P({}, n, {
              value: _e
            })
          });
        }
        oe < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var be = E.ReactCurrentDispatcher, ve;
    function R(n, s, u) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            ve = g && g[1] || "";
          }
        return `
` + ve + n;
      }
    }
    var S = !1, H;
    {
      var ie = typeof WeakMap == "function" ? WeakMap : Map;
      H = new ie();
    }
    function h(n, s) {
      if (!n || S)
        return "";
      {
        var u = H.get(n);
        if (u !== void 0)
          return u;
      }
      var g;
      S = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var V;
      V = be.current, be.current = null, ge();
      try {
        if (s) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (fe) {
              g = fe;
            }
            Reflect.construct(n, [], w);
          } else {
            try {
              w.call();
            } catch (fe) {
              g = fe;
            }
            n.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (fe) {
            g = fe;
          }
          n();
        }
      } catch (fe) {
        if (fe && g && typeof fe.stack == "string") {
          for (var _ = fe.stack.split(`
`), Q = g.stack.split(`
`), B = _.length - 1, U = Q.length - 1; B >= 1 && U >= 0 && _[B] !== Q[U]; )
            U--;
          for (; B >= 1 && U >= 0; B--, U--)
            if (_[B] !== Q[U]) {
              if (B !== 1 || U !== 1)
                do
                  if (B--, U--, U < 0 || _[B] !== Q[U]) {
                    var ne = `
` + _[B].replace(" at new ", " at ");
                    return n.displayName && ne.includes("<anonymous>") && (ne = ne.replace("<anonymous>", n.displayName)), typeof n == "function" && H.set(n, ne), ne;
                  }
                while (B >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        S = !1, be.current = V, $e(), Error.prepareStackTrace = $;
      }
      var Ce = n ? n.displayName || n.name : "", Dr = Ce ? R(Ce) : "";
      return typeof n == "function" && H.set(n, Dr), Dr;
    }
    function Ne(n, s, u) {
      return h(n, !1);
    }
    function Se(n) {
      var s = n.prototype;
      return !!(s && s.isReactComponent);
    }
    function Ee(n, s, u) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return h(n, Se(n));
      if (typeof n == "string")
        return R(n);
      switch (n) {
        case y:
          return R("Suspense");
        case d:
          return R("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case p:
            return Ne(n.render);
          case b:
            return Ee(n.type, s, u);
          case j: {
            var g = n, $ = g._payload, V = g._init;
            try {
              return Ee(V($), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var We = Object.prototype.hasOwnProperty, Sr = {}, wr = E.ReactDebugCurrentFrame;
    function Be(n) {
      if (n) {
        var s = n._owner, u = Ee(n.type, n._source, s ? s.type : null);
        wr.setExtraStackFrame(u);
      } else
        wr.setExtraStackFrame(null);
    }
    function wt(n, s, u, g, $) {
      {
        var V = Function.call.bind(We);
        for (var w in n)
          if (V(n, w)) {
            var _ = void 0;
            try {
              if (typeof n[w] != "function") {
                var Q = Error((g || "React class") + ": " + u + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Q.name = "Invariant Violation", Q;
              }
              _ = n[w](s, w, g, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (B) {
              _ = B;
            }
            _ && !(_ instanceof Error) && (Be($), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", u, w, typeof _), Be(null)), _ instanceof Error && !(_.message in Sr) && (Sr[_.message] = !0, Be($), v("Failed %s type: %s", u, _.message), Be(null));
          }
      }
    }
    var Ct = Array.isArray;
    function ar(n) {
      return Ct(n);
    }
    function Rt(n) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return u;
      }
    }
    function Tt(n) {
      try {
        return Cr(n), !1;
      } catch {
        return !0;
      }
    }
    function Cr(n) {
      return "" + n;
    }
    function Rr(n) {
      if (Tt(n))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rt(n)), Cr(n);
    }
    var ke = E.ReactCurrentOwner, Ot = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Tr, Or, or;
    or = {};
    function Pt(n) {
      if (We.call(n, "ref")) {
        var s = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function $t(n) {
      if (We.call(n, "key")) {
        var s = Object.getOwnPropertyDescriptor(n, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Nt(n, s) {
      if (typeof n.ref == "string" && ke.current && s && ke.current.stateNode !== s) {
        var u = ee(ke.current.type);
        or[u] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ee(ke.current.type), n.ref), or[u] = !0);
      }
    }
    function kt(n, s) {
      {
        var u = function() {
          Tr || (Tr = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function At(n, s) {
      {
        var u = function() {
          Or || (Or = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var It = function(n, s, u, g, $, V, w) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: n,
        key: s,
        ref: u,
        props: w,
        // Record the component responsible for creating this element.
        _owner: V
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function Dt(n, s, u, g, $) {
      {
        var V, w = {}, _ = null, Q = null;
        u !== void 0 && (Rr(u), _ = "" + u), $t(s) && (Rr(s.key), _ = "" + s.key), Pt(s) && (Q = s.ref, Nt(s, $));
        for (V in s)
          We.call(s, V) && !Ot.hasOwnProperty(V) && (w[V] = s[V]);
        if (n && n.defaultProps) {
          var B = n.defaultProps;
          for (V in B)
            w[V] === void 0 && (w[V] = B[V]);
        }
        if (_ || Q) {
          var U = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          _ && kt(w, U), Q && At(w, U);
        }
        return It(n, _, Q, $, g, ke.current, w);
      }
    }
    var ir = E.ReactCurrentOwner, Pr = E.ReactDebugCurrentFrame;
    function we(n) {
      if (n) {
        var s = n._owner, u = Ee(n.type, n._source, s ? s.type : null);
        Pr.setExtraStackFrame(u);
      } else
        Pr.setExtraStackFrame(null);
    }
    var sr;
    sr = !1;
    function cr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === r;
    }
    function $r() {
      {
        if (ir.current) {
          var n = ee(ir.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Mt(n) {
      {
        if (n !== void 0) {
          var s = n.fileName.replace(/^.*[\\\/]/, ""), u = n.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Nr = {};
    function Ft(n) {
      {
        var s = $r();
        if (!s) {
          var u = typeof n == "string" ? n : n.displayName || n.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function kr(n, s) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var u = Ft(s);
        if (Nr[u])
          return;
        Nr[u] = !0;
        var g = "";
        n && n._owner && n._owner !== ir.current && (g = " It was passed a child from " + ee(n._owner.type) + "."), we(n), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, g), we(null);
      }
    }
    function Ar(n, s) {
      {
        if (typeof n != "object")
          return;
        if (ar(n))
          for (var u = 0; u < n.length; u++) {
            var g = n[u];
            cr(g) && kr(g, s);
          }
        else if (cr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var $ = x(n);
          if (typeof $ == "function" && $ !== n.entries)
            for (var V = $.call(n), w; !(w = V.next()).done; )
              cr(w.value) && kr(w.value, s);
        }
      }
    }
    function jt(n) {
      {
        var s = n.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === b))
          u = s.propTypes;
        else
          return;
        if (u) {
          var g = ee(s);
          wt(u, n.props, "prop", g, n);
        } else if (s.PropTypes !== void 0 && !sr) {
          sr = !0;
          var $ = ee(s);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vt(n) {
      {
        for (var s = Object.keys(n.props), u = 0; u < s.length; u++) {
          var g = s[u];
          if (g !== "children" && g !== "key") {
            we(n), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), we(null);
            break;
          }
        }
        n.ref !== null && (we(n), v("Invalid attribute `ref` supplied to `React.Fragment`."), we(null));
      }
    }
    function Ir(n, s, u, g, $, V) {
      {
        var w = he(n);
        if (!w) {
          var _ = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Q = Mt($);
          Q ? _ += Q : _ += $r();
          var B;
          n === null ? B = "null" : ar(n) ? B = "array" : n !== void 0 && n.$$typeof === r ? (B = "<" + (ee(n.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : B = typeof n, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", B, _);
        }
        var U = Dt(n, s, u, $, V);
        if (U == null)
          return U;
        if (w) {
          var ne = s.children;
          if (ne !== void 0)
            if (g)
              if (ar(ne)) {
                for (var Ce = 0; Ce < ne.length; Ce++)
                  Ar(ne[Ce], n);
                Object.freeze && Object.freeze(ne);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ar(ne, n);
        }
        return n === a ? Vt(U) : jt(U), U;
      }
    }
    function Lt(n, s, u) {
      return Ir(n, s, u, !0);
    }
    function Yt(n, s, u) {
      return Ir(n, s, u, !1);
    }
    var zt = Yt, Wt = Lt;
    Ie.Fragment = a, Ie.jsx = zt, Ie.jsxs = Wt;
  }()), Ie;
}
process.env.NODE_ENV === "production" ? lr.exports = Xt() : lr.exports = Qt();
var je = lr.exports;
function en(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function rn(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var tn = /* @__PURE__ */ function() {
  function e(t) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(rn(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = en(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Z = "-ms-", Xe = "-moz-", N = "-webkit-", yr = "comm", gr = "rule", br = "decl", nn = "@import", st = "@keyframes", an = "@layer", on = Math.abs, er = String.fromCharCode, sn = Object.assign;
function cn(e, r) {
  return K(e, 0) ^ 45 ? (((r << 2 ^ K(e, 0)) << 2 ^ K(e, 1)) << 2 ^ K(e, 2)) << 2 ^ K(e, 3) : 0;
}
function ct(e) {
  return e.trim();
}
function un(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function k(e, r, t) {
  return e.replace(r, t);
}
function dr(e, r) {
  return e.indexOf(r);
}
function K(e, r) {
  return e.charCodeAt(r) | 0;
}
function Ve(e, r, t) {
  return e.slice(r, t);
}
function se(e) {
  return e.length;
}
function Er(e) {
  return e.length;
}
function Ge(e, r) {
  return r.push(e), e;
}
function fn(e, r) {
  return e.map(r).join("");
}
var rr = 1, Te = 1, ut = 0, re = 0, q = 0, Oe = "";
function tr(e, r, t, a, o, i, f) {
  return { value: e, root: r, parent: t, type: a, props: o, children: i, line: rr, column: Te, length: f, return: "" };
}
function De(e, r) {
  return sn(tr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function ln() {
  return q;
}
function dn() {
  return q = re > 0 ? K(Oe, --re) : 0, Te--, q === 10 && (Te = 1, rr--), q;
}
function te() {
  return q = re < ut ? K(Oe, re++) : 0, Te++, q === 10 && (Te = 1, rr++), q;
}
function ce() {
  return K(Oe, re);
}
function Ke() {
  return re;
}
function ze(e, r) {
  return Ve(Oe, e, r);
}
function Le(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ft(e) {
  return rr = Te = 1, ut = se(Oe = e), re = 0, [];
}
function lt(e) {
  return Oe = "", e;
}
function He(e) {
  return ct(ze(re - 1, pr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function pn(e) {
  for (; (q = ce()) && q < 33; )
    te();
  return Le(e) > 2 || Le(q) > 3 ? "" : " ";
}
function vn(e, r) {
  for (; --r && te() && !(q < 48 || q > 102 || q > 57 && q < 65 || q > 70 && q < 97); )
    ;
  return ze(e, Ke() + (r < 6 && ce() == 32 && te() == 32));
}
function pr(e) {
  for (; te(); )
    switch (q) {
      case e:
        return re;
      case 34:
      case 39:
        e !== 34 && e !== 39 && pr(q);
        break;
      case 40:
        e === 41 && pr(e);
        break;
      case 92:
        te();
        break;
    }
  return re;
}
function hn(e, r) {
  for (; te() && e + q !== 47 + 10; )
    if (e + q === 42 + 42 && ce() === 47)
      break;
  return "/*" + ze(r, re - 1) + "*" + er(e === 47 ? e : te());
}
function mn(e) {
  for (; !Le(ce()); )
    te();
  return ze(e, re);
}
function yn(e) {
  return lt(Ze("", null, null, null, [""], e = ft(e), 0, [0], e));
}
function Ze(e, r, t, a, o, i, f, l, p) {
  for (var y = 0, d = 0, b = f, j = 0, A = 0, M = 0, m = 1, x = 1, E = 1, v = 0, C = "", F = o, c = i, z = a, T = C; x; )
    switch (M = v, v = te()) {
      case 40:
        if (M != 108 && K(T, b - 1) == 58) {
          dr(T += k(He(v), "&", "&\f"), "&\f") != -1 && (E = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        T += He(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        T += pn(M);
        break;
      case 92:
        T += vn(Ke() - 1, 7);
        continue;
      case 47:
        switch (ce()) {
          case 42:
          case 47:
            Ge(gn(hn(te(), Ke()), r, t), p);
            break;
          default:
            T += "/";
        }
        break;
      case 123 * m:
        l[y++] = se(T) * E;
      case 125 * m:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            x = 0;
          case 59 + d:
            E == -1 && (T = k(T, /\f/g, "")), A > 0 && se(T) - b && Ge(A > 32 ? Br(T + ";", a, t, b - 1) : Br(k(T, " ", "") + ";", a, t, b - 2), p);
            break;
          case 59:
            T += ";";
          default:
            if (Ge(z = Wr(T, r, t, y, d, o, l, C, F = [], c = [], b), i), v === 123)
              if (d === 0)
                Ze(T, r, z, z, F, i, b, l, c);
              else
                switch (j === 99 && K(T, 3) === 110 ? 100 : j) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ze(e, z, z, a && Ge(Wr(e, z, z, 0, 0, o, l, C, o, F = [], b), c), o, c, b, l, a ? F : c);
                    break;
                  default:
                    Ze(T, z, z, z, [""], c, 0, l, c);
                }
        }
        y = d = A = 0, m = E = 1, C = T = "", b = f;
        break;
      case 58:
        b = 1 + se(T), A = M;
      default:
        if (m < 1) {
          if (v == 123)
            --m;
          else if (v == 125 && m++ == 0 && dn() == 125)
            continue;
        }
        switch (T += er(v), v * m) {
          case 38:
            E = d > 0 ? 1 : (T += "\f", -1);
            break;
          case 44:
            l[y++] = (se(T) - 1) * E, E = 1;
            break;
          case 64:
            ce() === 45 && (T += He(te())), j = ce(), d = b = se(C = T += mn(Ke())), v++;
            break;
          case 45:
            M === 45 && se(T) == 2 && (m = 0);
        }
    }
  return i;
}
function Wr(e, r, t, a, o, i, f, l, p, y, d) {
  for (var b = o - 1, j = o === 0 ? i : [""], A = Er(j), M = 0, m = 0, x = 0; M < a; ++M)
    for (var E = 0, v = Ve(e, b + 1, b = on(m = f[M])), C = e; E < A; ++E)
      (C = ct(m > 0 ? j[E] + " " + v : k(v, /&\f/g, j[E]))) && (p[x++] = C);
  return tr(e, r, t, o === 0 ? gr : l, p, y, d);
}
function gn(e, r, t) {
  return tr(e, r, t, yr, er(ln()), Ve(e, 2, -2), 0);
}
function Br(e, r, t, a) {
  return tr(e, r, t, br, Ve(e, 0, a), Ve(e, a + 1, -1), a);
}
function Re(e, r) {
  for (var t = "", a = Er(e), o = 0; o < a; o++)
    t += r(e[o], o, e, r) || "";
  return t;
}
function bn(e, r, t, a) {
  switch (e.type) {
    case an:
      if (e.children.length)
        break;
    case nn:
    case br:
      return e.return = e.return || e.value;
    case yr:
      return "";
    case st:
      return e.return = e.value + "{" + Re(e.children, a) + "}";
    case gr:
      e.value = e.props.join(",");
  }
  return se(t = Re(e.children, a)) ? e.return = e.value + "{" + t + "}" : "";
}
function En(e) {
  var r = Er(e);
  return function(t, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](t, a, o, i) || "";
    return f;
  };
}
function _n(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function xn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var Sn = function(r, t, a) {
  for (var o = 0, i = 0; o = i, i = ce(), o === 38 && i === 12 && (t[a] = 1), !Le(i); )
    te();
  return ze(r, re);
}, wn = function(r, t) {
  var a = -1, o = 44;
  do
    switch (Le(o)) {
      case 0:
        o === 38 && ce() === 12 && (t[a] = 1), r[a] += Sn(re - 1, t, a);
        break;
      case 2:
        r[a] += He(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = ce() === 58 ? "&\f" : "", t[a] = r[a].length;
          break;
        }
      default:
        r[a] += er(o);
    }
  while (o = te());
  return r;
}, Cn = function(r, t) {
  return lt(wn(ft(r), t));
}, Ur = /* @__PURE__ */ new WeakMap(), Rn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !Ur.get(a)) && !o) {
      Ur.set(r, !0);
      for (var i = [], f = Cn(t, i), l = a.props, p = 0, y = 0; p < f.length; p++)
        for (var d = 0; d < l.length; d++, y++)
          r.props[y] = i[p] ? f[p].replace(/&\f/g, l[d]) : l[d] + " " + f[p];
    }
  }
}, Tn = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, On = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Pn = function(r) {
  return r.type === "comm" && r.children.indexOf(On) > -1;
}, $n = function(r) {
  return function(t, a, o) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!t.parent, l = f ? t.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var y = l[p];
          if (y.line < t.line)
            break;
          if (y.column < t.column) {
            if (Pn(y))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, dt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Nn = function(r, t) {
  for (var a = r - 1; a >= 0; a--)
    if (!dt(t[a]))
      return !0;
  return !1;
}, qr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, kn = function(r, t, a) {
  dt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), qr(r)) : Nn(t, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), qr(r)));
};
function pt(e, r) {
  switch (cn(e, r)) {
    case 5103:
      return N + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return N + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return N + e + Xe + e + Z + e + e;
    case 6828:
    case 4268:
      return N + e + Z + e + e;
    case 6165:
      return N + e + Z + "flex-" + e + e;
    case 5187:
      return N + e + k(e, /(\w+).+(:[^]+)/, N + "box-$1$2" + Z + "flex-$1$2") + e;
    case 5443:
      return N + e + Z + "flex-item-" + k(e, /flex-|-self/, "") + e;
    case 4675:
      return N + e + Z + "flex-line-pack" + k(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return N + e + Z + k(e, "shrink", "negative") + e;
    case 5292:
      return N + e + Z + k(e, "basis", "preferred-size") + e;
    case 6060:
      return N + "box-" + k(e, "-grow", "") + N + e + Z + k(e, "grow", "positive") + e;
    case 4554:
      return N + k(e, /([^-])(transform)/g, "$1" + N + "$2") + e;
    case 6187:
      return k(k(k(e, /(zoom-|grab)/, N + "$1"), /(image-set)/, N + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return k(e, /(image-set\([^]*)/, N + "$1$`$1");
    case 4968:
      return k(k(e, /(.+:)(flex-)?(.*)/, N + "box-pack:$3" + Z + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + N + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return k(e, /(.+)-inline(.+)/, N + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (se(e) - 1 - r > 6)
        switch (K(e, r + 1)) {
          case 109:
            if (K(e, r + 4) !== 45)
              break;
          case 102:
            return k(e, /(.+:)(.+)-([^]+)/, "$1" + N + "$2-$3$1" + Xe + (K(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~dr(e, "stretch") ? pt(k(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (K(e, r + 1) !== 115)
        break;
    case 6444:
      switch (K(e, se(e) - 3 - (~dr(e, "!important") && 10))) {
        case 107:
          return k(e, ":", ":" + N) + e;
        case 101:
          return k(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + N + (K(e, 14) === 45 ? "inline-" : "") + "box$3$1" + N + "$2$3$1" + Z + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (K(e, r + 11)) {
        case 114:
          return N + e + Z + k(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return N + e + Z + k(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return N + e + Z + k(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return N + e + Z + e + e;
  }
  return e;
}
var An = function(r, t, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case br:
        r.return = pt(r.value, r.length);
        break;
      case st:
        return Re([De(r, {
          value: k(r.value, "@", "@" + N)
        })], o);
      case gr:
        if (r.length)
          return fn(r.props, function(i) {
            switch (un(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Re([De(r, {
                  props: [k(i, /:(read-\w+)/, ":" + Xe + "$1")]
                })], o);
              case "::placeholder":
                return Re([De(r, {
                  props: [k(i, /:(plac\w+)/, ":" + N + "input-$1")]
                }), De(r, {
                  props: [k(i, /:(plac\w+)/, ":" + Xe + "$1")]
                }), De(r, {
                  props: [k(i, /:(plac\w+)/, Z + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, In = [An], Dn = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(m) {
      var x = m.getAttribute("data-emotion");
      x.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || In;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(m) {
      for (var x = m.getAttribute("data-emotion").split(" "), E = 1; E < x.length; E++)
        i[x[E]] = !0;
      l.push(m);
    }
  );
  var p, y = [Rn, Tn];
  process.env.NODE_ENV !== "production" && y.push($n({
    get compat() {
      return M.compat;
    }
  }), kn);
  {
    var d, b = [bn, process.env.NODE_ENV !== "production" ? function(m) {
      m.root || (m.return ? d.insert(m.return) : m.value && m.type !== yr && d.insert(m.value + "{}"));
    } : _n(function(m) {
      d.insert(m);
    })], j = En(y.concat(o, b)), A = function(x) {
      return Re(yn(x), j);
    };
    p = function(x, E, v, C) {
      d = v, process.env.NODE_ENV !== "production" && E.map !== void 0 && (d = {
        insert: function(c) {
          v.insert(c + E.map);
        }
      }), A(x ? x + "{" + E.styles + "}" : E.styles), C && (M.inserted[E.name] = !0);
    };
  }
  var M = {
    key: t,
    sheet: new tn({
      key: t,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return M.sheet.hydrate(l), M;
}, vr = { exports: {} }, I = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gr;
function Mn() {
  if (Gr)
    return I;
  Gr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, j = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function C(c) {
    if (typeof c == "object" && c !== null) {
      var z = c.$$typeof;
      switch (z) {
        case r:
          switch (c = c.type, c) {
            case p:
            case y:
            case a:
            case i:
            case o:
            case b:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case M:
                case A:
                case f:
                  return c;
                default:
                  return z;
              }
          }
        case t:
          return z;
      }
    }
  }
  function F(c) {
    return C(c) === y;
  }
  return I.AsyncMode = p, I.ConcurrentMode = y, I.ContextConsumer = l, I.ContextProvider = f, I.Element = r, I.ForwardRef = d, I.Fragment = a, I.Lazy = M, I.Memo = A, I.Portal = t, I.Profiler = i, I.StrictMode = o, I.Suspense = b, I.isAsyncMode = function(c) {
    return F(c) || C(c) === p;
  }, I.isConcurrentMode = F, I.isContextConsumer = function(c) {
    return C(c) === l;
  }, I.isContextProvider = function(c) {
    return C(c) === f;
  }, I.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, I.isForwardRef = function(c) {
    return C(c) === d;
  }, I.isFragment = function(c) {
    return C(c) === a;
  }, I.isLazy = function(c) {
    return C(c) === M;
  }, I.isMemo = function(c) {
    return C(c) === A;
  }, I.isPortal = function(c) {
    return C(c) === t;
  }, I.isProfiler = function(c) {
    return C(c) === i;
  }, I.isStrictMode = function(c) {
    return C(c) === o;
  }, I.isSuspense = function(c) {
    return C(c) === b;
  }, I.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === y || c === i || c === o || c === b || c === j || typeof c == "object" && c !== null && (c.$$typeof === M || c.$$typeof === A || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === x || c.$$typeof === E || c.$$typeof === v || c.$$typeof === m);
  }, I.typeOf = C, I;
}
var D = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jr;
function Fn() {
  return Jr || (Jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, j = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function C(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === y || h === i || h === o || h === b || h === j || typeof h == "object" && h !== null && (h.$$typeof === M || h.$$typeof === A || h.$$typeof === f || h.$$typeof === l || h.$$typeof === d || h.$$typeof === x || h.$$typeof === E || h.$$typeof === v || h.$$typeof === m);
    }
    function F(h) {
      if (typeof h == "object" && h !== null) {
        var Ne = h.$$typeof;
        switch (Ne) {
          case r:
            var Se = h.type;
            switch (Se) {
              case p:
              case y:
              case a:
              case i:
              case o:
              case b:
                return Se;
              default:
                var Ee = Se && Se.$$typeof;
                switch (Ee) {
                  case l:
                  case d:
                  case M:
                  case A:
                  case f:
                    return Ee;
                  default:
                    return Ne;
                }
            }
          case t:
            return Ne;
        }
      }
    }
    var c = p, z = y, T = l, Pe = f, de = r, he = d, X = a, O = M, ee = A, P = t, oe = i, me = o, pe = b, ue = !1;
    function ye(h) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(h) || F(h) === p;
    }
    function W(h) {
      return F(h) === y;
    }
    function G(h) {
      return F(h) === l;
    }
    function _e(h) {
      return F(h) === f;
    }
    function xe(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function ge(h) {
      return F(h) === d;
    }
    function $e(h) {
      return F(h) === a;
    }
    function be(h) {
      return F(h) === M;
    }
    function ve(h) {
      return F(h) === A;
    }
    function R(h) {
      return F(h) === t;
    }
    function S(h) {
      return F(h) === i;
    }
    function H(h) {
      return F(h) === o;
    }
    function ie(h) {
      return F(h) === b;
    }
    D.AsyncMode = c, D.ConcurrentMode = z, D.ContextConsumer = T, D.ContextProvider = Pe, D.Element = de, D.ForwardRef = he, D.Fragment = X, D.Lazy = O, D.Memo = ee, D.Portal = P, D.Profiler = oe, D.StrictMode = me, D.Suspense = pe, D.isAsyncMode = ye, D.isConcurrentMode = W, D.isContextConsumer = G, D.isContextProvider = _e, D.isElement = xe, D.isForwardRef = ge, D.isFragment = $e, D.isLazy = be, D.isMemo = ve, D.isPortal = R, D.isProfiler = S, D.isStrictMode = H, D.isSuspense = ie, D.isValidElementType = C, D.typeOf = F;
  }()), D;
}
process.env.NODE_ENV === "production" ? vr.exports = Mn() : vr.exports = Fn();
var jn = vr.exports, vt = jn, Vn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Ln = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ht = {};
ht[vt.ForwardRef] = Vn;
ht[vt.Memo] = Ln;
var Yn = !0;
function zn(e, r, t) {
  var a = "";
  return t.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var mt = function(r, t, a) {
  var o = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Yn === !1) && r.registered[o] === void 0 && (r.registered[o] = t.styles);
}, Wn = function(r, t, a) {
  mt(r, t, a);
  var o = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Bn(e) {
  for (var r = 0, t, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    t = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Un = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Kr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, qn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Gn = /[A-Z]|^ms/g, yt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, _r = function(r) {
  return r.charCodeAt(1) === 45;
}, Hr = function(r) {
  return r != null && typeof r != "boolean";
}, ur = /* @__PURE__ */ xn(function(e) {
  return _r(e) ? e : e.replace(Gn, "-$&").toLowerCase();
}), Qe = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(yt, function(a, o, i) {
          return ae = {
            name: o,
            styles: i,
            next: ae
          }, o;
        });
  }
  return Un[r] !== 1 && !_r(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var Jn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Kn = ["normal", "none", "initial", "inherit", "unset"], Hn = Qe, Zn = /^-ms-/, Xn = /-(.)/g, Zr = {};
  Qe = function(r, t) {
    if (r === "content" && (typeof t != "string" || Kn.indexOf(t) === -1 && !Jn.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var a = Hn(r, t);
    return a !== "" && !_r(r) && r.indexOf("-") !== -1 && Zr[r] === void 0 && (Zr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Zn, "ms-").replace(Xn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var gt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ye(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(gt);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return ae = {
          name: t.name,
          styles: t.styles,
          next: ae
        }, t.name;
      if (t.styles !== void 0) {
        var a = t.next;
        if (a !== void 0)
          for (; a !== void 0; )
            ae = {
              name: a.name,
              styles: a.styles,
              next: ae
            }, a = a.next;
        var o = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (o += t.map), o;
      }
      return Qn(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = ae, f = t(e);
        return ae = i, Ye(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = t.replace(yt, function(d, b, j) {
          var A = "animation" + l.length;
          return l.push("const " + A + " = keyframes`" + j.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var y = r[t];
  return y !== void 0 ? y : t;
}
function Qn(e, r, t) {
  var a = "";
  if (Array.isArray(t))
    for (var o = 0; o < t.length; o++)
      a += Ye(e, r, t[o]) + ";";
  else
    for (var i in t) {
      var f = t[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Hr(f) && (a += ur(i) + ":" + Qe(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(gt);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Hr(f[l]) && (a += ur(i) + ":" + Qe(i, f[l]) + ";");
        else {
          var p = Ye(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += ur(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(qn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Xr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, bt;
process.env.NODE_ENV !== "production" && (bt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var ae, Qr = function(r, t, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  ae = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += Ye(a, t, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(Kr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += Ye(a, t, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(Kr), i += f[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(bt, function(j) {
    return p = j, "";
  })), Xr.lastIndex = 0;
  for (var y = "", d; (d = Xr.exec(i)) !== null; )
    y += "-" + // $FlowFixMe we know it's not null
    d[1];
  var b = Bn(i) + y;
  return process.env.NODE_ENV !== "production" ? {
    name: b,
    styles: i,
    map: p,
    next: ae,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: b,
    styles: i,
    next: ae
  };
}, ea = function(r) {
  return r();
}, ra = le["useInsertionEffect"] ? le["useInsertionEffect"] : !1, ta = ra || ea, nr = {}.hasOwnProperty, xr = /* @__PURE__ */ le.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Dn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (xr.displayName = "EmotionCacheContext");
xr.Provider;
var na = function(r) {
  return /* @__PURE__ */ ot(function(t, a) {
    var o = it(xr);
    return r(t, o, a);
  });
}, Et = /* @__PURE__ */ le.createContext({});
process.env.NODE_ENV !== "production" && (Et.displayName = "EmotionThemeContext");
var et = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, aa = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return et(t[1]);
}, oa = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), ia = function(r) {
  return r.replace(/\$/g, "-");
}, sa = function(r) {
  if (r)
    for (var t = r.split(`
`), a = 0; a < t.length; a++) {
      var o = aa(t[a]);
      if (o) {
        if (oa.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return ia(o);
      }
    }
}, hr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", mr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", _t = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var a = {};
  for (var o in t)
    nr.call(t, o) && (a[o] = t[o]);
  if (a[hr] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var i = sa(new Error().stack);
    i && (a[mr] = i);
  }
  return a;
}, ca = function(r) {
  var t = r.cache, a = r.serialized, o = r.isStringTag;
  return mt(t, a, o), ta(function() {
    return Wn(t, a, o);
  }), null;
}, xt = /* @__PURE__ */ na(function(e, r, t) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[hr], i = [a], f = "";
  typeof e.className == "string" ? f = zn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = Qr(i, void 0, le.useContext(Et));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[mr];
    p && (l = Qr([l, "label:" + p + ";"]));
  }
  f += r.key + "-" + l.name;
  var y = {};
  for (var d in e)
    nr.call(e, d) && d !== "css" && d !== hr && (process.env.NODE_ENV === "production" || d !== mr) && (y[d] = e[d]);
  return y.ref = t, y.className = f, /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.createElement(ca, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ le.createElement(o, y));
});
process.env.NODE_ENV !== "production" && (xt.displayName = "EmotionCssPropInternal");
var St = xt, Me = je.Fragment;
function L(e, r, t) {
  return nr.call(r, "css") ? je.jsx(St, _t(e, r), t) : je.jsx(e, r, t);
}
function Je(e, r, t) {
  return nr.call(r, "css") ? je.jsxs(St, _t(e, r), t) : je.jsxs(e, r, t);
}
const ua = Y`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`, rt = Y`
  font-size: 14px;
  margin-right: 8px;
  color: ${J("grayBlue", "02")};
`;
function fa(e) {
  return Y`
    font-size: 14px;
    margin-left: 8px;
    margin-right: 16px;
    white-space: nowrap;
    color: ${e ? J("grayBlue", "07") : J("grayBlue", "02")};
  `;
}
const la = Y`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
`, tt = Y`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;
function fr(e, r) {
  let t = Y`
    color: ${J("grayBlue", "02")};
  `;
  return r && (t = Y`
      color: ${J("grayBlue", "07")};
    `), Y`
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: ${r ? "not-allowed" : "auto"};
    ${e};
    ${t};
  `;
}
function Fe(e, r, t, a, o) {
  let i = Y`
    color: ${o ? J(a ?? "blue", "01") : J("grayBlue", "02")};
  `, f = Y`
    background-color: ${o ? J(a ?? "blue", "07") : "unset"};
  `;
  t && (i = Y`
      color: ${o ? J(a ?? "blue", "05") : J("grayBlue", "07")};
    `, f = Y`
      background-color: ${o ? a ? J(a, "07") : J("grayBlue", "09") : "unset"};
    `);
  let l = Y``;
  !t && !o && (l = Y`
      &:hover {
        background-color: ${J("grayBlue", "09")};
      }
    `);
  let p = "32px";
  switch (r) {
    case "small":
      p = "24px";
      break;
    case "medium":
      p = "32px";
      break;
    case "large":
      p = "40px";
      break;
  }
  return Y`
    font-size: 14px;
    width: ${p};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: ${p};
    border-radius: 4px;
    cursor: ${t ? "not-allowed" : "pointer"};
    ${e};
    ${i};
    ${f};
    ${l};
  `;
}
function nt(e, r) {
  let t = "32px";
  switch (e) {
    case "small":
      t = "24px";
      break;
    case "medium":
      t = "32px";
      break;
    case "large":
      t = "40px";
      break;
  }
  return Y`
    font-family: inherit;
    font-size: 14px;
    color: ${J("grayBlue", "02")};
    width: ${t};
    box-sizing: border-box;
    text-align: center;
    background-color: ${J("grayBlue", "09")};
    border-radius: 4px;
    height: ${t};
    outline: none;
    border: none;

    &:hover {
      background-color: ${J("grayBlue", "08")};
    }

    &:focus-within {
      outline: none;
      background: none;
      border: 1px solid
        ${r ? J(r, "01") : J("blue", "01")};
      box-shadow: 0 0 8px 0 ${Ut("blue", "01")};
    }

    &:disabled {
      cursor: not-allowed;
      color: ${J("grayBlue", "05")};
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    &[type="number"] {
      -moz-appearance: textfield;
    }
  `;
}
const da = ot((e, r) => {
  var ve;
  const { disabled: t, hideOnSinglePage: a, pageSizeChangeResetCurrent: o, showJumper: i, showMore: f, simple: l, disableSimplePageJump: p, sizeCanChange: y, bufferSize: d = 0, current: b, defaultCurrent: j, pageSize: A, defaultPageSize: M, total: m = 0, itemRender: x, size: E = "medium", icons: v, onChange: C, onPageSizeChange: F, showTotal: c, inputBorderColorScheme: z, activeColorScheme: T, ...Pe } = e, de = 5, he = it(Kt), X = ((ve = he == null ? void 0 : he.locale) == null ? void 0 : ve.pagination) ?? Ht.pagination, [O, ee] = jr(1, {
    defaultValue: j,
    value: b
  }), [P, oe] = jr(10, {
    defaultValue: M,
    value: A
  }), [me, pe] = Mr(""), [ue, ye] = Mr(""), W = Math.ceil(m / P), G = Fr((R) => {
    let S = R;
    return R < 1 ? S = 1 : R > W && (S = W), m === 0 && (S = 0), b === void 0 && ee(S), C == null || C(S, P), S;
  }, [b, P, C, ee, m, W]), _e = Ue(() => Jt(c) ? L("div", { css: rt, children: c(m, [
    (O - 1) * P,
    (O - 1) * P + P <= m ? (O - 1) * P + P : (O - 1) * P + m % P
  ]) }) : L(Me, { children: c && L("span", { css: rt, children: X.total.replace("{0}", (m == null ? void 0 : m.toString()) ?? "") }) }), [O, P, X.total, c, m]), xe = Ue(() => L(Me, { children: i && Je("div", { css: la, children: [L("span", { css: fa(t), children: X.go }), L("input", { css: nt(E, z), value: me, type: "number", min: 1, max: W, disabled: t, onChange: (R) => {
    pe(R.currentTarget.value);
  }, onBlur: (R) => {
    R.currentTarget.value != "" && (G(Number(R.currentTarget.value)), pe(""));
  }, onKeyDown: (R) => {
    R.key === "Enter" && R.currentTarget.value != "" && (G(Number(R.currentTarget.value)), pe(""));
  } })] }) }), [
    G,
    t,
    z,
    me,
    X.go,
    i,
    E,
    W
  ]), ge = Fr((R) => {
    let S = !1;
    return O + d >= R && O - d <= R && (S = !0), (R === 1 || R == W) && (S = !0), O < de && R < de && (S = !0), S;
  }, [d, O, W, de]);
  Bt(() => {
    ye(O.toString());
  }, [O]);
  const $e = Ue(() => {
    let R;
    if (l)
      R = Je("div", { css: tt, children: [p ? L("span", { css: fr(Y``, t), children: ue }) : L("input", { css: nt(E), type: "number", min: 1, max: W, value: ue, disabled: t, onChange: (S) => {
        ye(S.currentTarget.value);
      }, onBlur: (S) => {
        S.currentTarget.value != "" && G(Number(S.currentTarget.value));
      }, onKeyDown: (S) => {
        S.key === "Enter" && S.currentTarget.value != "" && G(Number(S.currentTarget.value));
      } }), L("span", { css: fr(Y`
                  margin-left: 8px;
                  margin-right: 8px;
                `, t), children: "/" }), L("span", { css: fr(Y``, t), children: W })] });
    else {
      const S = [];
      for (let H = 0; H < W; H++) {
        const ie = H + 1, h = O === ie;
        ge(ie) ? S.push(L("span", { css: Fe(Y`
                    margin-right: ${H != W - 1 ? "8px" : "unset"};
                  `, E, t, T, h), onClick: () => {
          t || G(ie);
        }, children: H + 1 })) : ge(ie - 1) && S.push(L("span", { css: Fe(Y`
                      margin-right: ${H != W - 1 ? "8px" : "unset"};
                    `, E, t), onClick: () => {
          t || (ie < O ? G(O - d - 1) : ie > O && G(O + d + 1));
        }, children: (x == null ? void 0 : x(P, "more", (v == null ? void 0 : v.more) ?? L(qe, {}))) ?? L(qe, {}) }));
      }
      R = L(Me, { children: S });
    }
    return Je("div", { css: tt, children: [L("span", { css: Fe(Y`
                margin-right: 8px;
              `, E, t || O === 1 || m === 0), onClick: () => {
      t || O === 1 || m === 0 || G(O - 1);
    }, children: (x == null ? void 0 : x(P, "prev", (v == null ? void 0 : v.prev) ?? L(Vr, {}))) ?? L(Vr, {}) }), R, f && L("span", { css: Fe(Y`
                  margin-left: 8px;
                `, E, t), onClick: () => {
      t || G(O + d + 1);
    }, children: (x == null ? void 0 : x(P, "more", (v == null ? void 0 : v.more) ?? L(qe, {}))) ?? L(qe, {}) }), L("span", { css: Fe(Y`
                margin-left: 8px;
              `, E, t || O === W || m === 0), onClick: () => {
      t || O === W || m === 0 || G(O + 1);
    }, children: (x == null ? void 0 : x(P, "next", (v == null ? void 0 : v.next) ?? L(Lr, {}))) ?? L(Lr, {}) })] });
  }, [
    d,
    G,
    ge,
    t,
    O,
    P,
    v == null ? void 0 : v.more,
    v == null ? void 0 : v.next,
    v == null ? void 0 : v.prev,
    x,
    f,
    l,
    ue,
    p,
    E,
    m,
    W
  ]), be = Ue(() => L(Me, { children: y && L(Zt, { options: [
    {
      label: `10/${X.page}`,
      value: "10"
    },
    {
      label: `20/${X.page}`,
      value: "20"
    },
    {
      label: `30/${X.page}`,
      value: "30"
    },
    {
      label: `40/${X.page}`,
      value: "40"
    },
    {
      label: `50/${X.page}`,
      value: "50"
    }
  ], disabled: t, ml: "8px", defaultValue: {
    label: P + "/" + X.page,
    value: P.toString()
  }, colorScheme: z, onChange: (R) => {
    if (R !== null) {
      let S = Number(R), H = o ? W > 0 ? 1 : 0 : Math.ceil(O * P / S);
      F == null || F(S, H), G(H), A === void 0 && oe(S);
    }
  } }) }), [
    G,
    t,
    O,
    P,
    z,
    X.page,
    F,
    A,
    o,
    oe,
    y,
    W
  ]);
  return a && m <= P ? L(Me, {}) : Je("div", { css: [ua, qt(e)], ref: r, ...Gt(Pe), children: [_e, $e, be, xe] });
});
da.displayName = "Pagination";
export {
  da as Pagination
};
//# sourceMappingURL=index.js.map
